$.fn.FTP_Uploader = function(_params) {
	var _up = this
	_up.params = _params
	_up.uploader = undefined

	_up.interface = {
		files: undefined,
		folder: undefined,
		holders: [],
		holder_template: undefined
	}

	_up.clear = function()
	{
		_up.interface.holders.forEach(function(x) {
			x.delete()
		})
		_up.interface.holders = []
	}

	/* Files */
	_up.filestart = function(e, file)
	{
		if (_up.interface.holders.length) {
			var file_holder = _up.interface.holders[file.index]
			file_holder.start()
		}
	}

	_up.fileprogress = function(e, file, percent)
	{
		if (_up.interface.holders.length) {
			var file_holder = _up.interface.holders[file.index]
			file_holder.percent(percent)
		}
	}

	_up.filecomplete = function(e, file, response)
	{
		if (_up.interface.holders.length) {
			var file_holder = _up.interface.holders[file.index]
			file_holder.end(response)
			_up.files.load()
		}
	}

	_up.fileerror = function(e, file, response)
	{
		if (_up.files != undefined) {
			_up.files.load()
		}
	}

	/* Queue */
	_up.queue_start = function(e, files)
	{
		if (!_up.params.multiple) {
			if (files.length > 1) {
				_up.uploader.upload("abort")
				return false
			}
			_up.clear()
		}
		_up.uploader.upload('disable')
		files.forEach(function(file) {
			if (_up.interface.files.length) {
				var file_holder = _up.interface.holder_template.clone().FTP_File(_up.files, _up, file.index)
				file_holder.addClass("waiting")
				file_holder.setFilename(file.name)
				_up.interface.holders[file.index] = file_holder
				_up.interface.files.prepend(file_holder)
				_up.interface.files.find('.dt-empty').parent().remove()
			}
		})
	}

	_up.queue_ended = function(e)
	{
		_up.uploader.upload('enable')
		if (_up.folders != undefined) {
			_up.folders.load()
		}
	}

	_up.current_files = function()
	{
		if (_up.interface.files.length) {
			_up.interface.files.find('tr').each(function(index, el) {
				var file_holder = $(this).FTP_File(_up, index)
				_up.interface.holders[index] = file_holder
			})
		}
	}

	_up.reset = function()
	{
		_up.disable()
		_up.interface.holders.forEach(function(x) {
			x.remove()
		})
		_up.interface.holders = []
	}

	_up.disable = function()
	{
		_up.uploader.upload('disable')
	}

	return function()
	{
		// files or folder
		_up.interface.files = _up.find('.ftp-table--files tbody')
		if (!_up.interface.files.length) {
			_up.interface.folder = _up.params.parent
		}

		// file holder template
		_up.interface.holder_template = _up.find(".file-holder-template").clone().removeClass("file-holder-template")

		// setup uploader
		_up.uploader = _up.find(".upload").upload({
			action: "/api/multiupload",
			autoUpload: true,
			multiple: _up.params.multiple,
			maxConcurrent: 1,
			maxSize: 268435456,
			label: _up.params.multiple ? 'Ajouter des fichiers' : 'Sélectionner un fichier',
			beforeSend: function(formData, file) {
				for (key in _up.params.data) {
					formData.append(key, _up.params.data[key])
				}
				formData.append('id', _up.params.id)
				formData.append('model', _up.params.model)
				if (_up.files != undefined && _up.files.length) {
					formData.append('contact_id', _up.files.ftp.bar.current.contact)
					formData.append('folder_id', _up.files.ftp.bar.current.reference)
					formData.append('file_tag', _up.files.ftp.bar.current.type)
				} else {
					formData.append('contact_id', _up.folders.ftp.bar.current.contact)
					formData.append('folder_id', _up.id)
				}
				return formData
			}
		})
		_up.uploader.on('start', _up.queue_start)
		_up.uploader.on('complete', _up.queue_ended)
		_up.uploader.on('filestart', _up.filestart)
		_up.uploader.on('filecomplete', _up.filecomplete)
		_up.uploader.on('fileerror', _up.fileerror)
		_up.uploader.on('fileprogress', _up.fileprogress)

		// load files
		_up.current_files()

		// return
		return _up
	}()
}

$.fn.FTP_Files = function(ftp) {
	let self = this

	self.ftp = ftp
	self.table = undefined
	self.response = undefined

	self.load = function() {
		$.ajax({
			url: '/fichier/json-files/',
			type: 'POST',
			data: {
				contact_id: ftp.bar.current.contact,
				folder_id: ftp.bar.current.reference,
			},
			dataType: 'json',
			success: function (response) {
				self.response = response
				self.table.clear()
				self.table.rows.add(response)
				self.table.draw()
				self.find('tr').each(function() {
					$(this).FTP_File(self)
				})
			},
		})
	}

	self.initialize_list = function() {
		self.table = self.DataTable({
			language: {
				url: '/assets/libraries/DataTables-fr_FR.json',
			},
			order: [[3, 'desc']],
			columnDefs: [
				{ targets: 1, orderable: true },
				{ targets: 2, orderable: false, width: '140px' },
				{ targets: 3, orderable: true, width: '140px' },
				{ targets: 4, orderable: false, width: '180px' }
			],
			layout: {
				topStart: null,
				topEnd: null,
				bottomStart: null,
				bottomEnd: null,
			},
			paging: false,
			initComplete: function() {
				$(this).addClass('d-none')
				$(this).closest('.dt-container').addClass('table-container--files')
			},
		})
		self.table.on('draw.dt', function() {
			self.find('tr').each(function() {
				$(this).FTP_File(self)
			})
		})
		$.fn.dataTable.ext.search.push(function(settings, data, dataIndex) {
			if (settings.nTable !== self.table.table().node()) return true
			const row_data = self.table.row(dataIndex).data()
			let should_be_visible = true
			if (ftp.bar.current.type != 0 && ftp.bar.current.type != 'all' && ftp.bar.current.type != row_data.type.value) {
				should_be_visible = false
			}
			if (!ftp.view_archived && row_data.archived) {
				should_be_visible = false
			}
			return should_be_visible
		})
	}

	return function() {
		self.initialize_list()
		return self
	}()
}

$.fn.FTP_File = function(files, uploader, index) {
	let self = this

	if (self.data('ftp-file')) {
		return self.data('ftp-file')
	}

	self.row_data = files.table.row(self).data()
	self.id = 0
	self.type = 0
	self.uploader = uploader
	self.input = $('<input type="text">')
	self.cell = self.find('a[data-value]')
	self.index = index
	self.filename = undefined
	self.archived = false

	self.button = {
		save: undefined,
		rename: undefined,
		cancel: undefined,
		archive: undefined,
		unarchive: undefined,
		duplicate: undefined,
		download: undefined,
	}

	self.download = function() {
		const link = document.createElement('a')
		link.href = self.cell.attr('href')
		link.target = '_blank'
		link.download = ''
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}

	self.archive = function() {
		$.ajax({
			url: '/fichier/api/',
			type: 'POST',
			data: {
				object_type: 'file',
				contact_id: files.ftp.bar.current.contact,
				file_id: self.id,
				file_action: self.archived ? 'unarchive' : 'archive',
			},
			dataType: 'json',
			success: function (response) {
				if (response.success) {
					files.load()
				} else {
					self.cancel()
				}
			},
		})
		if (self.archived) {
			self.archived = false
			self.removeClass('archived')
			self.button.archive.show()
			self.button.unarchive.hide()
		} else {
			self.archived = true
			self.addClass('archived')
			self.button.archive.hide()
			self.button.unarchive.show()
			if (!files.ftp.view_archived) {
				self.detach()
			}
		}
	}

	self.select_filename = function(inputElement) {
		const value = inputElement.value,
		lastDotIndex = value.lastIndexOf('.'),
		fileNameWithoutExtension = lastDotIndex > 0 ? value.slice(0, lastDotIndex) : value
		inputElement.setSelectionRange(0, fileNameWithoutExtension.length)
	}

	self.rename = function() {
		self.button.save.show()
		self.button.cancel.show()
		self.button.rename.hide()
		self.button.archive.hide()
		self.button.unarchive.hide()
		self.button.duplicate.hide()
		self.button.download.hide()
		$cell = self.find('td:first')
		$cell.find('a').hide()
		$cell.append(self.input.show().val($cell.find('a').text()))
		self.input.focus()
		self.select_filename(self.input.get(0))
		self.input.on('keydown', function(e) {
			if (e.key === 'Enter' || e.keyCode == 30) {
				e.preventDefault()
				self.save()
			}
			if (e.key === 'Escape' || e.keyCode == 27) {
				e.preventDefault()
				self.cancel()
			}
		})
	}

	self.save = function() {
		$.ajax({
			url: '/fichier/api/',
			type: 'POST',
			data: {
				object_type: 'file',
				contact_id: files.ftp.bar.current.contact,
				folder_id: files.ftp.bar.current.reference,
				file_id: self.id,
				filename: self.input.val().replace(/[^a-zA-Z0-9\s._'àâäéèêëïîôöùûüçÀÂÄÉÈÊËÏÎÔÖÙÛÜÇ#-]/g, '').trim(),
			},
			dataType: 'json',
			success: function (response) {
				if (response.success) {
					self.id = response.file_id
					self.cell.text(response.filename).attr('data-value', self.id)
					self.cancel()
					files.load()
				} else {
					self.cancel()
				}
			},
		})
	}

	self.set_type = function(new_type) {
		self.type = parseInt(new_type, 10)
		$.ajax({
			url: '/fichier/api/',
			type: 'POST',
			data: {
				object_type: 'file',
				contact_id: files.ftp.bar.current.contact,
				folder_id: files.ftp.bar.current.reference,
				file_id: self.id,
				file_tag: self.type,
			},
			dataType: 'json',
			success: function (response) {
				files.load()
			},
		})
	}

	self.duplicate = function() {
		$.ajax({
			url: '/fichier/api/',
			type: 'POST',
			data: {
				object_type: 'file',
				contact_id: files.ftp.bar.current.contact,
				file_id: self.id,
				file_action: 'duplicate',
			},
			dataType: 'json',
			success: function (response) {
				if (response.success) {
					files.load()
				}
			},
		})
	}

	self.cancel = function() {
		self.input.hide()
		self.cell.show()
		self.button.save.hide()
		self.button.cancel.hide()
		self.button.rename.show()
		self.button.duplicate.show()
		self.button.download.show()
		if (self.archived) {
			self.button.unarchive.show()
		} else {
			self.button.archive.show()
		}
	}

	self.initialize_buttons = function() {
		if (!self.find('button').length) {
			self.find('td:last-child:not(.dt-empty)').append($('.file-holder-template button').clone())
		}
		self.button = {
			save: self.find('.btn-file-save'),
			cancel: self.find('.btn-file-cancel'),
			rename: self.find('.btn-file-rename'),
			archive: self.find('.btn-file-archive'),
			unarchive: self.find('.btn-file-unarchive'),
			duplicate: self.find('.btn-file-duplicate'),
			download: self.find('.btn-file-download'),
		}
		self.button.save.on('click', self.save)
		self.button.cancel.on('click', self.cancel)
		self.button.rename.on('click', self.rename)
		self.button.archive.on('click', self.archive)
		self.button.unarchive.on('click', self.archive)
		self.button.duplicate.on('click', self.duplicate)
		self.button.download.on('click', self.download)

		self.cell.on('click', function() {
			window.open(self.cell.attr('href'), '_blank', `width=${screen.width * 3/5},height=${screen.height},scrollbars=yes,toolbar=no,location=no`)
			return false
		})
	}

	self.setFilename = function(filename) {
		self.filename = filename
		self.cell.text(filename)
	}

	self.start = function() {
		self.removeClass("waiting")
		self.addClass("transfering")
	}

	self.percent = function(percent) {
		self.find('.progress-bar').css({
			width : percent + '%',
		})
	}

	self.end = function(response) {
		self.removeClass("transfering")
		var data = JSON.parse(response),
		linkUrl = self.cell.attr('href')
		if (data.success || data.id) {
			self.find('.progress').fadeOut("fast")
			self.attr("data-file-id", data.id)
			self.cell.attr("href",  data.protected_url).show()
			if (self.uploader != undefined && self.uploader.params != undefined && self.uploader.params.callback != undefined) {
				self.uploader.params.callback()
			}
		} else {
			self.fadeOut("fast")
			$.slr.notify({
				icon: 'fa fa-exclamation-circle',
				title: "Erreur lors du transfert",
				message: data.error ? data.error : "Le transfert a échoué."
			}, {
				type: 'danger',
				delay: 15
			})
		}
	}

	self.initialize_type = function() {
		let $dropdown = $('<div>').append(files.ftp.bar.menu_template.type.clone()).find('.dropdown')
		$dropdown.find('.current-cell').text('Choisir un type')
		$dropdown.find('.dropdown-item:eq(0)').remove()
		$dropdown = $dropdown.FTP_Dropdown()
		self.find('.dropdown').replaceWith($dropdown)
		$dropdown.set_current_value(self.type)
		$dropdown.find('input').on('change', function() {
			self.set_type($(this).val())
		})
	}

	return function() {
		self.id = self.cell.data('value')
		self.type = self.find('.dropdown').text() ? parseInt(self.find('.dropdown').text(), 10) : 0
		self.initialize_buttons()
		self.initialize_type()
		if (self.closest('#ftp-module.panel').length) {
			self.cell.draggable({
				appendTo: 'body',
				helper: 'clone',
			})
		}
		if (self.row_data != undefined && self.row_data.archived == 1) {
			self.archived = true
			self.addClass('archived')
			self.button.archive.hide()
			self.button.unarchive.show()
		}
		self.data('ftp-file', self)
		return self
	}()
}

$.fn.FTP_Folders = function(ftp) {
	let self = this

	self.ftp = ftp
	self.table = undefined
	self.has_new = false
	self.response = undefined

	self.load = function() {
		$.ajax({
			url: '/fichier/json-folder/',
			type: 'POST',
			data: {
				contact_id: ftp.bar.current.contact,
			},
			dataType: 'json',
			success: function (response) {
				self.response = response
				self.table.clear()
				self.table.rows.add(response)
				self.table.draw()
				self.find('tr').each(function() {
					$(this).FTP_Folder(self)
				})
			},
		})
	}

	self.initialize_list = function() {
		self.table = self.DataTable({
			language: {
				url: '/assets/libraries/DataTables-fr_FR.json',
			},
			order: [[2, 'desc']],
			columnDefs: [
				{ targets: 1, orderable: true },
				{ targets: 2, orderable: true, width: '140px' },
				{ targets: 3, orderable: false, width: '180px' }
			],
			layout: {
				topStart: null,
				topEnd: null,
				bottomStart: null,
				bottomEnd: null,
			},
			paging: false,
			initComplete: function() {
				$(this).addClass('d-none')
				$(this).closest('.dt-container').addClass('table-container--folders')
			}
		})
		self.table.on('order.dt', function() {
			self.has_new = false
		})
		self.table.on('draw.dt', function() {
			ftp.bar.menu.reference.set_items(self.response)
			self.find('tr').each(function() {
				$(this).FTP_Folder(self)
			})
		})
		$.fn.dataTable.ext.search.push(function(settings, data, dataIndex) {
			if (settings.nTable !== self.table.table().node()) return true
			if (ftp.view_archived) return true
			const row_data = self.table.row(dataIndex).data()
			return !row_data.archived
		})
	}

	self.create_new = function() {
		if (self.has_new) {
			return
		}
		let template = $('.folder-holder-template').clone().removeClass('folder-holder-template').FTP_Folder(self)
		self.find('tbody').prepend(template)
		template.initialize_new()
		self.find('.dt-empty').parent().remove()
		self.has_new = true
	}

	return function() {
		self.initialize_list()
		return self
	}()
}

$.fn.FTP_Folder = function(folders) {
	let self = this

	if (self.data('ftp-folder')) {
		return self.data('ftp-folder')
	}

	self.folders = folders
	self.row_data = folders.table.row(self).data()
	self.id = 0
	self.input = $('<input type="text">')
	self.cell = self.find('a[data-value]')
	self.uploader = undefined
	self.archived = false

	self.button = {
		save: undefined,
		cancel: undefined,
		rename: undefined,
		archive: undefined,
		unarchive: undefined,
	}

	self.save = function() {
		$.ajax({
			url: '/fichier/api/',
			type: 'POST',
			data: {
				object_type: 'folder',
				contact_id: folders.ftp.bar.current.contact,
				folder_id: self.id,
				folder_reference: self.input.val().replace(/[^a-zA-Z0-9\s._'!?,àâäéèêëïîôöùûüçÀÂÄÉÈÊËÏÎÔÖÙÛÜÇ#-]/g, '').trim(),
			},
			dataType: 'json',
			success: function (response) {
				if (response.success) {
					folders.ftp.bar.menu.reference.add_item(response)
					self.id = response.folder_id
					self.cell.text(response.folder_reference).attr('data-value', self.id)
					self.cancel()
					folders.load()
				} else {
					self.cancel()
				}
			},
		})
	}

	self.cancel = function() {
		if (self.id == 0) {
			folders.has_new = false
			self.remove()
			folders.table.draw()
		} else {
			self.input.hide()
			self.cell.show()
			self.button.save.hide()
			self.button.cancel.hide()
			self.button.rename.show()
			if (self.archived) {
				self.button.unarchive.show()
			} else {
				self.button.archive.show()
			}
		}
	}

	self.rename = function() {
		self.button.save.show()
		self.button.cancel.show()
		self.button.rename.hide()
		self.button.archive.hide()
		self.button.unarchive.hide()
		$cell = self.find('td:first')
		$cell.find('a[data-value], .fs-upload-element, .files-count').hide()
		$cell.append(self.input.show().val($cell.find('a').text()))
		self.input.focus().select()
		self.input.on('keydown', function(e) {
			if (e.key === 'Enter' || e.keyCode == 30) {
				e.preventDefault()
				self.save()
			}
			if (e.key === 'Escape' || e.keyCode == 27) {
				e.preventDefault()
				self.cancel()
			}
		})
	}

	self.archive = function() {
		$.ajax({
			url: '/fichier/api/',
			type: 'POST',
			data: {
				object_type: 'folder',
				contact_id: folders.ftp.bar.current.contact,
				folder_id: self.id,
				folder_action: self.archived ? 'unarchive' : 'archive',
			},
			dataType: 'json',
			success: function (response) {
				if (response.success) {
					folders.load()
				} else {
					self.cancel()
				}
			},
		})
		if (self.archived) {
			self.archived = false
			self.removeClass('archived')
			self.button.archive.show()
			self.button.unarchive.hide()
		} else {
			self.archived = true
			self.addClass('archived')
			self.button.archive.hide()
			self.button.unarchive.show()
			if (!folders.ftp.view_archived) {
				self.detach()
			}
		}
	}

	self.initialize_buttons = function() {
		let is_new_folder = true
		if (!self.find('button').length) {
			is_new_folder = false
			self.find('td:last-child:not(.dt-empty)').append($('.folder-holder-template button').clone())
		}
		self.button = {
			save: self.find('.btn-folder-save'),
			cancel: self.find('.btn-folder-cancel'),
			rename: self.find('.btn-folder-rename'),
			archive: self.find('.btn-folder-archive'),
			unarchive: self.find('.btn-folder-unarchive'),
		}
		self.button.save.on('click', self.save)
		self.button.cancel.on('click', self.cancel)
		self.button.rename.on('click', self.rename)
		self.button.archive.on('click', self.archive)
		self.button.unarchive.on('click', self.archive)
		if (is_new_folder) {
			self.button.save.show()
			self.button.cancel.show()
			self.button.rename.hide()
			self.button.archive.hide()
			self.button.unarchive.hide()
		}
	}

	self.initialize_new = function() {
		self.find('td:first-child').append(self.input)
		self.input.focus()
		self.input.on('keydown', function(e) {
			if (e.key === 'Enter' || e.keyCode == 30) {
				e.preventDefault()
				self.save()
			}
			if (e.key === 'Escape' || e.keyCode == 27) {
				e.preventDefault()
				self.cancel()
			}
		})
	}

	self.initialize_uploader = function() {
		// Check if user has write permission
		if ($('#ftp-module').data('can-write') != '1') {
			return;
		}
		let $upload = $('<div>').addClass('upload')
		self.cell.before($upload)
		self.uploader = self.FTP_Uploader({
			parent: self,
			model : 'ftp',
			id : 0,
			multiple: true,
		})
	}

	return function() {
		self.id = self.cell.data('value')
		self.cell.on('click', function(e) {
			folders.ftp.bar.menu.reference.set_current_value($(this).data('value'))
		})
		self.initialize_buttons()
		self.initialize_uploader()
		if (self.row_data != undefined && self.row_data.archived == 1) {
			self.archived = true
			self.addClass('archived')
			self.button.archive.hide()
			self.button.unarchive.show()
		}
		self.data('ftp-folder', self)
		return self
	}()
}

$.fn.FTP_Dropdown = function(bar, with_search) {
	let self = this

	if (with_search == undefined) {
		with_search = false
	}

	self.dd = self.find('.dropdown-menu')
	self.cell = self.find('.current-cell')
	self.input = self.find('input[type="hidden"]')
	self.searchInput = undefined

	if (with_search) {
		let searchHtml = '<div class="dropdown-search-container"><input type="text" class="dropdown-search form-control" placeholder="Rechercher"><button type="button" class="dropdown-search-clear"><span class="material-symbols-outlined">backspace</span></button></div>'
		self.dd.prepend(searchHtml)
		self.searchInput = self.dd.find('.dropdown-search')

		self.on('shown.bs.dropdown', function() {
			self.searchInput.focus()
		})

		self.searchInput.on('click', function(e) {
			e.stopPropagation()
		})

		self.dd.find('.dropdown-search-clear').on('click', function(e) {
			e.stopPropagation()
			self.searchInput.val('')
			self.searchInput.focus()
			self.searchInput.trigger('keyup')
		})

		self.searchInput.on('keyup', function() {
			let filter = $(this).val().toLowerCase().trim()
			let searchTerms = filter.split(/\s+/)
			self.dd.find('.dropdown-item').each(function() {
				let text = $(this).text().toLowerCase()
				let match = searchTerms.every(function(term) { return text.indexOf(term) > -1 })
				if (match) {
					$(this).show()
				} else {
					$(this).hide()
				}
			})
		})

		self.searchInput.on('keydown', function(e) {
			let $visibleItems = self.dd.find('.dropdown-item:visible')
			let $current = self.dd.find('.dropdown-item.highlighted')
			if (e.keyCode === 40) {
				e.preventDefault()
				if ($current.length === 0) {
					$visibleItems.first().addClass('highlighted')
				} else {
					let currentIndex = $visibleItems.index($current)
					$current.removeClass('highlighted')
					if (currentIndex < $visibleItems.length - 1) {
						$visibleItems.eq(currentIndex + 1).addClass('highlighted')
					} else {
						$visibleItems.first().addClass('highlighted')
					}
				}
			} else if (e.keyCode === 38) {
				e.preventDefault()
				if ($current.length === 0) {
					$visibleItems.last().addClass('highlighted')
				} else {
					let currentIndex = $visibleItems.index($current)
					$current.removeClass('highlighted')
					if (currentIndex > 0) {
						$visibleItems.eq(currentIndex - 1).addClass('highlighted')
					} else {
						$visibleItems.last().addClass('highlighted')
					}
				}
			} else if (e.keyCode === 13) {
				e.preventDefault()
				if ($current.length > 0) {
					$current.trigger('click')
				}
			} else {
				self.dd.find('.dropdown-item.highlighted').removeClass('highlighted')
			}
		})
	}

	self.clear_search = function() {
		if (self.searchInput != undefined) {
			self.searchInput.val('')
			self.searchInput.focus()
			self.searchInput.trigger('keyup')
		}
	}

	self.reorder = function() {
		let $searchContainer = self.dd.find('.dropdown-search-container').detach()
		let $firstItem = self.dd.find('.dropdown-item[data-value="all"]').detach()
		let $items = self.dd.find('.dropdown-item:not([data-value="all"])').detach()
		let $sortedItems = $items.sort((a, b) => $(a).text().localeCompare($(b).text()))
		self.dd.empty().append($searchContainer).append($firstItem).append($sortedItems)
	}

	self.add_item = function(reference) {
		self.find('.dropdown-item[data-value="' + reference.folder_id + '"]').remove()
		let $newItem = $('<a class="dropdown-item" href="#"></a>')
		.attr('data-value', reference.folder_id)
		.attr('aria-selected', 'false')
		.text(reference.folder_reference)
		$newItem.on('click', function() {
			self.set_current_item($(this))
		})
		self.dd.append($newItem)
		self.reorder()
	}

	self.set_items = function(response) {
		if (response != undefined) {
			self.find('.dropdown-item:not([data-value="all"])').remove()
			response.forEach(function(reference) {
				if (!reference.archived || (bar != undefined && bar.ftp.view_archived)) {
					let $newItem = $('<a class="dropdown-item" href="#"></a>')
					.attr('data-value', reference.id.value)
					.attr('aria-selected', 'false')
					.text(reference.reference.value)
					if (reference.archived) {
						$newItem.addClass('archived')
					}
					$newItem.on('click', function() {
						self.set_current_item($(this))
					})
					self.dd.append($newItem)
				}
			})
			self.reorder()
		}
	}

	self.set_current_value = function(value) {
		self.set_current_item(self.find('.dropdown-item[data-value="' + value + '"]'))
	}

	self.set_current_item = function($el) {
		// le fil d'Ariane garde le nom seul, sans le nom de la compagnie
		let $label = $el.clone()
		$label.find('.name-company').remove()
		self.cell.html($label.html())
		self.input.val($el.data('value')).change()
		self.dd.dropdown()
		self.dd.find('a').attr('aria-selected', 'false')
		$el.attr('aria-selected', 'true')
		if (bar != undefined) {
			self.cell.find('.material-symbols-outlined').remove()
		}
	}

	return (function() {
		self.dd.find('a').on('click', function() {
			self.set_current_item($(this))
		})
		return self
	})()
}

$.fn.FTP_Breadcrumb = function(ftp) {
	let self = this

	self.ftp = ftp

	self.input = {
		contact: self.find('input[name="ftp_contact"]'),
		reference: self.find('input[name="ftp_reference"]'),
		type: self.find('input[name="ftp_type"]')
	}

	self.menu_template = {
		type: self.find('#ftp-type-dropdown').clone(),
	}

	self.menu = {
		contact: self.find('#ftp-contact-dropdown').FTP_Dropdown(self, true),
		reference: self.find('#ftp-reference-dropdown').FTP_Dropdown(self, true),
		type: self.find('#ftp-type-dropdown').FTP_Dropdown(self, true),
	}

	self.current_as_string = ''
	self.current = {
		contact: self.input.contact.val(),
		reference: self.input.reference.val(),
		type: self.input.type.val(),
	}

	self.type_changed = function() {
		self.current.type = self.input.type.val()
		ftp.files.table.draw()
	}

	self.filters_changed = function() {
		self.old = self.current
		self.current = {
			contact: self.input.contact.val(),
			reference: self.input.reference.val(),
			type: self.input.type.val(),
		}
		if (JSON.stringify(self.current) != self.current_as_string) {
			self.current_as_string = JSON.stringify(self.current)
			if (self.current.contact == 'none') {
				self.menu.reference.addClass('d-none')
				self.menu.reference.clear_search()
				self.menu.reference.set_current_value('all')
				self.menu.type.addClass('d-none')
				self.menu.type.clear_search()
				self.menu.type.set_current_value('all')
				$('.btn-ftp-new-folder').addClass('disabled').prop('disabled', true)
				$('.btn-ftp-parent-folder').addClass('disabled').prop('disabled', true)
				$('.btn-ftp-view-hidden').addClass('disabled').prop('disabled', true)
				$('.ftp-table--files').addClass('d-none')
				$('.ftp-table--folders').addClass('d-none')
				$('#ftp-module .card-block:first').addClass('d-none')
				$('#ftp-module .card-block.new-files').removeClass('d-none')
				$('.btn-invoice-for-artist').addClass('disabled')
				$('.contact-invoices').addClass('d-none')
				ftp.folders.table.clear()
				ftp.folders.table.draw()
				$.slr.interface.table.clear().draw()
			} else if (self.current.contact != 'none') {
				$('.contact-invoices').removeClass('d-none')
				$('.btn-invoice-for-artist').removeClass('disabled').attr('href', '/facture/ajouter/type/' + self.current.contact)
				$('#ftp-module .card-block.new-files').addClass('d-none')
				$('#ftp-module .card-block:first').removeClass('d-none')
				$('.btn-ftp-view-hidden').removeClass('disabled').prop('disabled', false)
				self.menu.reference.removeClass('d-none')
				if (self.current.reference == 'all') {
					$('.btn-ftp-new-folder').removeClass('disabled').prop('disabled', false)
					$('.btn-ftp-upload-file').addClass('disabled').prop('disabled', true)
					if (ftp.is_mini) {
						$('.btn-ftp-parent-folder').addClass('disabled').prop('disabled', true)
					} else {
						$('.btn-ftp-parent-folder').removeClass('disabled').prop('disabled', false)
					}
					self.menu.type.addClass('d-none')
					self.menu.type.clear_search()
					$('.ftp-table--files').addClass('d-none')
					$('.ftp-table--folders').removeClass('d-none')
					ftp.folders.load()
					ftp.files.table.clear()
					ftp.files.table.draw()
				} else if (self.current.reference != 'all') {
					$('.btn-invoice-for-artist').removeClass('disabled').attr('href', '/facture/ajouter/type/' + self.current.contact)
					$('.btn-ftp-new-folder').addClass('disabled').prop('disabled', true)
					$('.btn-ftp-upload-file').removeClass('disabled').prop('disabled', false)
					$('.btn-ftp-parent-folder').removeClass('disabled').prop('disabled', false)
					self.menu.type.removeClass('d-none')
					$('.ftp-table--files').removeClass('d-none')
					$('.ftp-table--folders').addClass('d-none')
					ftp.files.load()
				}
			}
			if (self.old.contact != self.current.contact) {
				$.slr.interface.table.ajax.url('/facture/json/' + self.current.contact).load();
				ftp.folders.table.clear()
				ftp.folders.table.draw()
				self.menu.reference.set_current_value('all')
				self.menu.reference.clear_search()
				self.menu.type.set_current_value('all')
				self.menu.type.clear_search()
			}
		}
	}

	self.go_to_parent = function() {
		if (self.current.reference != 'all') {
			self.menu.reference.set_current_value('all')
			self.menu.type.set_current_value('all')
			self.menu.type.clear_search()
		} else if (self.current.contact != 'none') {
			self.menu.contact.set_current_value('none')
			self.menu.reference.clear_search()
			self.menu.type.clear_search()
		}
	}

	self.close_panel = function() {
		ftp.removeClass('panel--open')
	}

	self.toggle_view_archived = function() {
		if ($(this).hasClass('btn-outline-secondary')) {
			$(this).removeClass('btn-outline-secondary').addClass('btn-secondary')
			$(this).find('.material-symbols-outlined').text('visibility')
			ftp.view_archived = true
		} else {
			$(this).removeClass('btn-secondary').addClass('btn-outline-secondary')
			$(this).find('.material-symbols-outlined').text('visibility_off')
			ftp.view_archived = false
		}
		$(this).blur()
		ftp.folders.table.draw()
		ftp.files.table.draw()
	}

	self.new_folder = function() {
		if (self.current.reference != 'all') {
			self.menu.reference.set_current_value('all')
			self.menu.reference.clear_search()
			self.menu.type.clear_search()
		}
		ftp.folders.create_new()
	}

	self.trigger_upload = function() {
		$('.ftp-files-upload .fs-upload-input').click()
	}

	self.initialize_buttons = function() {
		$('.btn-ftp-upload-file').on('click', self.trigger_upload)
		$('.btn-ftp-parent-folder').on('click', self.go_to_parent)
		$('.btn-ftp-close-panel').on('click', self.close_panel)
		$('.btn-ftp-view-hidden').on('click', self.toggle_view_archived)
		$('.btn-ftp-new-folder').on('click', self.new_folder)

		if (ftp.is_mini) {
			$('.btn-ftp-parent-folder').removeClass('ml-2').addClass('ml-3')
		}
	}

	return function() {
		self.initialize_buttons()
		self.input.contact.on('change', self.filters_changed)
		self.input.reference.on('change', self.filters_changed)
		self.input.type.on('change', self.type_changed)
		setTimeout(self.filters_changed, 200)
		return self
	}()
}

$.fn.FTP_Module = function() {
	let self = this

	self.uploader = undefined
	self.drag_timeout = undefined
	self.folders = undefined
	self.files = undefined
	self.is_mini = self.hasClass('panel')
	self.view_archived = false

	self.initialize_uploader = function() {
		if (self.is_mini) {
			return
		}

		// Check if user has write permission
		if (self.data('can-write') != '1') {
			return;
		}

		self.uploader = self.FTP_Uploader({
			parent: self,
			model : 'ftp',
			id : 0,
			multiple: true,
		})

		$('html').on('dragover', function(e) {
			if (!e.originalEvent.dataTransfer.types.includes('Files')) {
				return
			}
			$('.table-container--files').addClass('disabled')
			$('.ftp-files-upload, .fs-upload-element').addClass('active')
			clearTimeout(self.drag_timeout)
			self.drag_timeout = setTimeout(function() {
				clearTimeout(self.drag_timeout)
				$('.table-container--files').removeClass('disabled')
				$('.ftp-files-upload').removeClass('active')
			}, 3000)
		})

		$('html').on('click', function() {
			$('.table-container--files').removeClass('disabled')
			$('.ftp-files-upload, .fs-upload-element').removeClass('active')
		})

		$('.fs-upload-target').on('drop', function(e) {
			$('.table-container--files').removeClass('disabled')
			$('.ftp-files-upload, .fs-upload-element').removeClass('active')
		})
	}

	self.initialize_interface = function() {
		self.bar = $('#ftp-breadcrumb').FTP_Breadcrumb(self)
		self.folders = $('.ftp-table--folders').FTP_Folders(self)
		self.files = $('.ftp-table--files').FTP_Files(self)

		$('button[data-contact]').on('click', function() {
			self.folders.ftp.bar.menu.contact.set_current_value($(this).data('contact'))
		})

		setTimeout(function() {
			if (window.location.hash) {
				self.folders.ftp.bar.menu.contact.set_current_value(window.location.hash.substring(1))
				history.replaceState(null, '', location.pathname + location.search);
			}
		}, 100)
	}

	return function() {
		self.initialize_interface()
		self.initialize_uploader()
		return self
	}()
}
